(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inu-webbook-image"] && !Shopify.designMode) return;
  try {
    
  class InuWebbookImage {
    constructor(root) {
      this.root = root;
      this.pages = Array.from(root.querySelectorAll('[data-wbi-page]'));
      if (this.pages.length === 0) return;

      this.current = root.querySelector('[data-wbi-current]');
      this.trackReading();
      this.bindIndex();
      this.bindZoom();
      this.bindTop();
    }

    /* 上端の線で読了率を、右下でいま何ページ目かを示す */
    trackReading() {
      const bar = this.root.querySelector('[data-wbi-progress]');

      const update = () => {
        if (bar) {
          const total = this.root.scrollHeight - window.innerHeight;
          const seen = window.scrollY - this.root.offsetTop;
          const ratio = total > 0 ? Math.min(Math.max(seen / total, 0), 1) : 0;
          bar.style.width = `${ratio * 100}%`;
        }

        const middle = window.scrollY + window.innerHeight / 2;
        let page = this.pages[0];
        this.pages.forEach((candidate) => {
          if (candidate.offsetTop <= middle) page = candidate;
        });
        if (this.current) this.current.textContent = page.dataset.wbiPage;
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }

    bindIndex() {
      const panel = this.root.querySelector('[data-wbi-index]');
      const open = this.root.querySelector('[data-wbi-index-open]');
      const close = this.root.querySelector('[data-wbi-index-close]');
      if (!panel || !open) return;

      const setOpen = (state) => {
        panel.hidden = !state;
        open.setAttribute('aria-expanded', String(state));
        document.body.style.overflow = state ? 'hidden' : '';
      };

      open.addEventListener('click', () => setOpen(true));
      close?.addEventListener('click', () => setOpen(false));
      panel.querySelectorAll('[data-wbi-goto]').forEach((link) => {
        link.addEventListener('click', () => setOpen(false));
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) setOpen(false);
      });
    }

    bindZoom() {
      const zoom = this.root.querySelector('[data-wbi-zoom]');
      const image = this.root.querySelector('[data-wbi-zoom-image]');
      if (!zoom || !image) return;

      const setOpen = (state) => {
        zoom.hidden = !state;
        document.body.style.overflow = state ? 'hidden' : '';
        if (!state) image.src = '';
      };

      this.root.querySelectorAll('[data-wbi-zoomable]').forEach((page) => {
        page.addEventListener('click', () => {
          image.src = page.currentSrc || page.src;
          image.alt = page.alt;
          setOpen(true);
          zoom.scrollTop = 0;
          zoom.scrollLeft = 0;
        });
      });

      this.root.querySelector('[data-wbi-zoom-close]')?.addEventListener('click', () => setOpen(false));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !zoom.hidden) setOpen(false);
      });
    }

    bindTop() {
      this.root.querySelector('[data-wbi-top]')?.addEventListener('click', () => {
        this.pages[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  document.querySelectorAll('[data-wbi]').forEach((root) => new InuWebbookImage(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
